import { render, staticRenderFns } from "./ProductsImpuestosFilter.vue?vue&type=template&id=b6ac4742&scoped=true"
import script from "./ProductsImpuestosFilter.vue?vue&type=script&lang=js"
export * from "./ProductsImpuestosFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ac4742",
  null
  
)

export default component.exports